import { render, staticRenderFns } from "./MedicationsList.vue?vue&type=template&id=47a946e6&"
import script from "./MedicationsList.vue?vue&type=script&lang=js&"
export * from "./MedicationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports